<div class="header-actions">
  <app-paste-query-from-saved (pasted)="paste($event)" (removed)="remove($event)" type="order">
  </app-paste-query-from-saved>
  <app-append-query-popover (appended)="append($event, builder.value)">
  </app-append-query-popover>
</div>

<mat-dialog-content>
  <app-query-builder #builder [fields]="fieldMap$ | async" [ruleSet]="ruleSet">
  </app-query-builder>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button color="warn" mat-dialog-close mat-stroked-button>{{ 'QUERY_BUILDER.close' | translate }}</button>
  <button [mat-dialog-close]="{ chainedId: chainedId, ruleSet: builder.value }"
          color="primary"
          mat-stroked-button>
    {{ 'QUERY_BUILDER.apply' | translate }}
  </button>
</mat-dialog-actions>
